<template>
	<v-hover v-slot="{hover}">

		<app-icon class="component-container"
				  :color="hover ? 'white' : ''"
				  icon="close"
				  title="Close"/>

	</v-hover>
</template>

<script>
export default {
	name: "CloseIcon"
}
</script>

<style scoped>
.component-container {
	aspect-ratio: 1/1;
	padding: 8px;
	transition: 0.3s;
	width: 40px;
}

.component-container:hover {
	background: var(--v-red-base);
	border-radius: 50%;
	padding: 8px;
	transition: 0.3s;
}
</style>
